import React from 'react';
import { RiHome6Line } from 'react-icons/ri';
import { v4 as uuidv4 } from 'uuid';

import Mode from './Mode';

import { MODE } from '@/define/robotStatus';

const Panel = ({ data: robots }) => {
  return (
    <Mode
      data={robots}
      modeId={MODE.ARDUPILOT.PLANE.QRTL.id}
      desc="QuadPlane returns to launch in vertical flight mode"
    />
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'QRTL';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiHome6Line;
Command.Panel = Panel;

export default Command;
